<template>
  <work-editor-main mode="edit" />
</template>

<script>
import WorkEditorMain from './WorkEditorMain.vue'

export default {
  name: 'EditWorkV2',
  components: {
    WorkEditorMain
  }
}
</script>
